// import library
import { Routes, Route, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";
// import context
import { AuthContext } from "../context";
import { env } from "../env";
import { initGA, logPageView } from "../analytics";
// import files
import ProtectedRoute from "./ProtectedRoute";
import UnProtectedRoute from "./UnProtectedRoute";
import Login from "../views/Account/Login";
import Dashboard from "../views/Home/Dashboard";
import ForgotPassword from "../views/Account/ForgotPassword";
import OrderIndex from "../views/Order/Index";
import OrderCreate from "../views/Order/Create";
import OrderHistoryIndex from "../views/Order/History";
import OrderView from "../views/Order/View";
import ResetPassword from "../views/Account/ResetPassword";
import ErrorPage from "../views/Other/Error";
import OrderDraftIndex from "../views/Order/Draft";
import ProductIndex from "../views/Product/Index";
import ProfileIndex from "../views/Profile/Index";
import Setting from "../views/Profile/Settings";
import Notification from "../views/Profile/Notifications";
import LastOrderIndex from "../views/Order/LastOrder";
import OrderAgain from "../views/Order/OrderAgain";
import CustomerProfileIndex from "../views/Profile/CustomerProfileIndex";
import ProfileView from "../views/Profile/View";
import ProfileEdit from "../views/Profile/Edit";
import TransactionView from "../views/Profile/TransactionView";
import CreateAgreement from "../views/Profile/CreateAgreement";
import CreateAsset from "../views/Profile/CreateAsset";
import EditAsset from "../views/Profile/EditAsset";
import CreateCoupon from "../views/Profile/CreateCoupon";
import CreateTask from "../views/Profile/CreateTask";
import TaskTemplateIndex from "../views/Profile/TaskTemplateIndex";
import EditTask from "../views/Profile/EditTask";
import CopyTask from "../views/Profile/CopyTask";
import TaskIndex from "../views/Profile/TaskIndex";
import AppointmentIndex from "../views/Profile/AppointmentIndex";
import MapView from "../views/Profile/MapView";
import CustomerView from "../views/Customer/View";
import PrivacyPolicy from "../views/Other/PrivacyPolicy";

const AppRoutes = () => {
    const authContext = useContext(AuthContext);
    const location = useLocation();

    useEffect(() => {
        initGA();
        logPageView(location.pathname);
        if(!authContext.isAuthenticated) return;
    }, [authContext.isAuthenticated, location]);

    return (
        <Routes>
            <Route path="*" element={<ErrorPage />} />

            {/* public */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* auth */}
            <Route path="/" element={
                <UnProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <Login />
                </UnProtectedRoute>
            } />
            <Route path="/forgot-password" element={ 
                <UnProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <ForgotPassword />
                </UnProtectedRoute>
            } />
            <Route path="/reset-password" element={
                <UnProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <ResetPassword />
                </UnProtectedRoute>
            } />

            {/* home */}
            <Route path="/dashboard" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <Dashboard />
                </ProtectedRoute>
            } />

            {/* order */}
            <Route path="/orders" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <OrderIndex />
                </ProtectedRoute>
            } />
            <Route path="/orders/create/:customerid" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <OrderCreate />
                </ProtectedRoute>
            } />
            <Route path="/order/history" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <OrderHistoryIndex />
                </ProtectedRoute>
            } />
            <Route path="/order/history/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <OrderView />
                </ProtectedRoute>
            } />
            <Route path="/order/history/create/:id/:customerid" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <OrderAgain />
                </ProtectedRoute>
            } />
            {/* <Route path="/order/draft" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <OrderDraftIndex />
                </ProtectedRoute>
            } /> */}
            <Route path="/order/last" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <LastOrderIndex />
                </ProtectedRoute>
            } />
            
            {/* customer */}
            <Route path="/customers" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <CustomerProfileIndex />
                </ProtectedRoute>
            } />
            <Route path="/customers/detail/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <CustomerView />
                </ProtectedRoute>
            } />
            <Route path="/customers/transaction/:documentNumber/:customerId/:date" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <TransactionView />
                </ProtectedRoute>
            } />

            {/* profile */}
            <Route path="/profile/overview" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <ProfileIndex />
                </ProtectedRoute>
            } />
            <Route path="/profiles" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <CustomerProfileIndex />
                </ProtectedRoute>
            } />
            <Route path="/profiles/detail/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <ProfileView />
                </ProtectedRoute>
            } />
            <Route path="/profiles/edit/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <ProfileEdit />
                </ProtectedRoute>
            } />
            
            <Route path="/profiles/create-agreement/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <CreateAgreement />
                </ProtectedRoute>
            } />
            <Route path="/profiles/create-asset/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <CreateAsset />
                </ProtectedRoute>
            } />
            <Route path="/profiles/edit-asset/:id/:customerId" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <EditAsset />
                </ProtectedRoute>
            } />
            <Route path="/profiles/create-coupon/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <CreateCoupon />
                </ProtectedRoute>
            } />
            <Route path="/profiles/task/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <TaskIndex />
                </ProtectedRoute>
            } />
            <Route path="/profiles/task-templates/:customerId" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <TaskTemplateIndex />
                </ProtectedRoute>
            } />
            <Route path="/profiles/create-task/:id/:customerId" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <CreateTask />
                </ProtectedRoute>
            } />
            <Route path="/profiles/edit-task/:id/:customerId" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <EditTask />
                </ProtectedRoute>
            } />
            <Route path="/profiles/copy-task/:id/:customerId" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <CopyTask />
                </ProtectedRoute>
            } />
            <Route path="/profiles/appointment/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <AppointmentIndex />
                </ProtectedRoute>
            } />
            <Route path="/profiles/map-view/:id" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <MapView />
                </ProtectedRoute>
            } />
            {/* settings */}
            <Route path="/profile/settings" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <Setting />
                </ProtectedRoute>
            } />
            <Route path="/profile/notifications" element={
                <ProtectedRoute isAuthenticated={authContext.isAuthenticated}>
                    <Notification />
                </ProtectedRoute>
            } />
        </Routes>
    )
}

export default AppRoutes